var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04841 0.27163L3.43746 5.76105L1.61826 3.98125C1.24805 3.61907 0.64787 3.61907 0.277659 3.98125C-0.0925529 4.34343 -0.0925529 4.93062 0.277659 5.29279L2.76716 7.72837C3.13737 8.09054 3.73754 8.09054 4.10776 7.72837L10.389 1.58318C10.7592 1.22101 10.7592 0.633812 10.389 0.27163C10.0188 -0.0905432 9.41862 -0.0905432 9.04841 0.27163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.23b9cd2970a711e4cd1c1ab33da25d5e.svg";
export { ForwardRef as ReactComponent };